module.exports = __webpack_public_path__ + "static/media/logo.f155b0db.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 171
// module chunks = 0